// extracted by mini-css-extract-plugin
module.exports = {"centered":"centered___2aswy","options":"options___1m2Ia"};